import { render } from "./App.vue?vue&type=template&id=7c85902f&bindings={\"headerMessage\":\"data\",\"compare\":\"data\",\"showMessage\":\"data\",\"showMessageContent\":\"data\",\"sortedCardsId\":\"data\",\"sortedCards\":\"data\",\"oGcards\":\"data\",\"selector\":\"options\",\"clearCompareArr\":\"options\",\"clearMessage\":\"options\",\"clearSortedArr\":\"options\",\"sort\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script